import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/withdrawal`;

class WithdrawalMangementServices {
  async getWithdrawalList(page, limit, filter, status, fromDate, toDate) {
    try {
      const params = new URLSearchParams({ page: String(page), limit: String(limit) });
      if (filter) params.set("filter", filter);
      if (status) params.set("status", status);
      if (fromDate) params.set("from_date", fromDate);
      if (toDate) params.set("to_date", toDate);
      const response = await requestToken.get(
        `${API_ROUTE}/get-withdrawal-list?${params.toString()}`
      );
      return response;
    } catch (error) {
      console.error("Error in getWithdrawalList:", error);
      throw error;
    }
  }

  async requestWithdraw(amount, remark) {
    try {
      const payload = { amount, remark };
      const response = await requestToken.post(
        `${API_ROUTE}/request-withdraw`,
        payload
      );
      return response;
    } catch (error) {
      console.error("Error in requestWithdraw:", error);
      throw error;
    }
  }

  async updateStatus(id, action, adminRemark) {
    try {
      const payload = { id, action, admin_remark: adminRemark };
      const response = await requestToken.post(
        `${API_ROUTE}/update-status`,
        payload
      );
      return response;
    } catch (error) {
      console.error("Error in updateStatus:", error);
      throw error;
    }
  }
}

export default WithdrawalMangementServices